import { IconTypes } from "~/components/Icon/types";
import { AssetClassPage } from "./types";
import { Routes } from "~/routes";

// // // //

export const ASSET_CLASS_PAGES_TO_ICON: Record<AssetClassPage, IconTypes> = {
    stablecoins: IconTypes.Coins,
    treasuries: IconTypes.BuildingColumns,
    government_bonds: IconTypes.MoneyBill,
    credit: IconTypes.SquareList,
    stocks: IconTypes.PieChartCircleDollar,
    pe_vc: IconTypes.BriefcaseBusiness,
    active_strategies: IconTypes.Crosshairs,
    commodities: IconTypes.OilWell,
    real_estate: IconTypes.Home,
};

// Display label for each asset class page, used anywhere the page is shown as
// a chip/preset (AssetPicker, ExploreQuickFilters).
export const ASSET_CLASS_PAGE_TO_LABEL: Record<AssetClassPage, string> = {
    stablecoins: "Stablecoins",
    treasuries: "Tokenized U.S. Treasury Funds",
    government_bonds: "Non-U.S. Govt. Debt",
    credit: "Credit",
    stocks: "Stocks",
    pe_vc: "PE / VC",
    active_strategies: "Active Strategies",
    commodities: "Commodities",
    real_estate: "Real Estate",
};

// Display order for asset class page chips/presets, matching the sidebar's
// "Asset Classes" group.
export const ASSET_CLASS_PAGE_ORDER: AssetClassPage[] = [
    "stablecoins",
    "treasuries",
    "government_bonds",
    "credit",
    "stocks",
    "pe_vc",
    "active_strategies",
    "commodities",
    "real_estate",
];

export const ASSET_CLASS_PAGE_TO_ROUTE: Record<AssetClassPage, string> = {
    stablecoins: Routes.stablecoins,
    treasuries: Routes.treasuries,
    government_bonds: Routes.governmentBonds,
    credit: Routes.credit,
    stocks: Routes.stocks,
    pe_vc: Routes.privateEquity,
    active_strategies: Routes.activeStrategies,
    commodities: Routes.commodities,
    real_estate: Routes.realEstate,
};
